// Affichage d'une ville de départ avec sa date ("Marseille · 20/10").
// La date arrive de l'API en texte AAAA-MM-JJ : on la découpe sans passer par Date
// pour éviter tout décalage de fuseau.
export const formatDateCourte = (iso) => {
  if (!iso) return "";
  const [, m, j] = String(iso).slice(0, 10).split("-");
  return j + "/" + m;
};

// Date manquante volontairement visible ("date ?") : ne jamais la remplacer par la date de session
export const libelleVilleDate = (ville, date) => {
  if (!ville) return "Non renseignée";
  return ville + " · " + (date ? formatDateCourte(date) : "date ?");
};
